import DesignPlaceholder from '@99designs/common/components/DesignPlaceholder/DesignPlaceholder';
import spaces from '@99designs/common/core/settings/spaces';
import { typeScale } from '@99designs/common/core/settings/typography';
import Icon from 'launch/components/Icon';
import React from 'react';
import styled from 'styled-components';
import { Designer } from './DesignerDetails';
import Img from './Img';
import Paginator from './Paginator';

const DesignCount = styled.span`
    position: absolute;
    top: ${spaces.space6}px;
    right: ${spaces.space6}px;
    z-index: 1;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 19px;
    padding: ${spaces.space3}px;
    width: 40px;
    text-align: center;
    font-size: ${typeScale.size1}px;
`;

interface Props {
    designer: Designer;
    showPaginators?: boolean;
    isClickable: boolean;
    onClick: () => void;
    onChange: (designIndex: number) => void;
    selectedIndex: number;
}

class DesignCarousel extends React.Component<Props> {
    get hasPrev() {
        return this.props.selectedIndex > 0;
    }

    get hasNext() {
        return this.props.selectedIndex < this.props.designer.profile.designs.length - 1;
    }

    prev = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (this.hasPrev) {
            this.props.onChange(this.props.selectedIndex - 1);
        }
    };

    next = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (this.hasNext) {
            this.props.onChange(this.props.selectedIndex + 1);
        }
    };

    render() {
        const { showPaginators = true } = this.props;
        const { designs } = this.props.designer.profile;

        if (designs.length == 0) {
            return (
                <div className="design-carousel">
                    <div className="design-carousel__content">
                        <div className="design-carousel__viewport">
                            <DesignPlaceholder size="large" icon={'design-1'}>
                                {__('No designs available')}
                            </DesignPlaceholder>
                        </div>
                    </div>
                    {showPaginators && (
                        <div className="design-carousel__paginator">
                            <Paginator
                                steps={designs.length}
                                selectedIndex={this.props.selectedIndex}
                                onSelectIndex={selectedIndex => this.props.onChange(selectedIndex)}
                            />
                        </div>
                    )}
                </div>
            );
        }

        return (
            <>
                <div className="design-carousel">
                    <DesignCount>
                        {this.props.selectedIndex + 1}/{designs.length}
                    </DesignCount>
                    <div className="design-carousel__content">
                        {designs.length > 0 && (
                            <div
                                className={`design-carousel__control ${
                                    this.props.isClickable
                                        ? 'design-carousel__control--clickable'
                                        : ''
                                }`}
                                onClick={() => this.props.onClick()}
                            >
                                {this.hasPrev && (
                                    <button
                                        className="design-carousel__control__prev"
                                        onClick={this.prev}
                                    >
                                        <Icon icon="left-4" />
                                    </button>
                                )}
                                {this.hasNext && (
                                    <button
                                        className="design-carousel__control__next"
                                        onClick={this.next}
                                    >
                                        <Icon icon="right-4" />
                                    </button>
                                )}
                            </div>
                        )}
                        <div className="design-carousel__viewport">
                            <div
                                className="design-carousel__items"
                                style={{
                                    transform: `translateX(-${this.props.selectedIndex * 100}%)`,
                                }}
                            >
                                {designs.map((design, idx) => (
                                    <div className="design-carousel__item" key={idx}>
                                        <Img
                                            src={design.image}
                                            alt={design.title}
                                            key={idx}
                                            preload={idx > 0}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {showPaginators && (
                        <div className="design-carousel__paginator">
                            <Paginator
                                steps={designs.length}
                                selectedIndex={this.props.selectedIndex}
                                onSelectIndex={selectedIndex => this.props.onChange(selectedIndex)}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }
}

export default DesignCarousel;
